import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import moment from "moment";
import { Button, Modal,Row,Col} from "antd";
import ReportingSelect from "../../../components/ReportingSelect";
import { useGlobalData } from "../../context/GlobalDataContext";  // Import the global context
import { Link } from "react-router-dom";
import AttendanceInfoModal from "../../../components/modelpopup/AttendanceInfoModal"; // Import the modal



const AttendanceEmployeeWeekly = () => {
  const [data, setData] = useState([]);
  const defaultEmployeeId = localStorage.getItem("defaultEmployeeId");
  const defaultEmployeeLabel = localStorage.getItem("defaultEmployeeLabel") || "Default Employee";
  const {
    holidays,
    weekends,
    weekStart,
    weekEnd,
    additionalOffDays,
    workingHours,
    loading: globalLoading,
  } = useGlobalData();  // Access the global data

  const [selectedEmployee, setSelectedEmployee] = useState(
    defaultEmployeeId ? { value: defaultEmployeeId, label: defaultEmployeeLabel } : null
  );
  
 
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  const [selectedDate, setSelectedDate] = useState(moment());
  const [loading, setLoading] = useState(true);
  const [currentTime, setCurrentTime] = useState(moment());
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const dateFormat = "MMM DD, YYYY";
  const maximizeBtnRef = useRef(null);
  const [isFullScreen, setFullScreen] = useState(false);
  const [modalData, setModalData] = useState(null); // Add this line

  const maxHours = workingHours; // Maximum working hours for calculating width
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(parseInt(localStorage.getItem("empid")) || null);
  const [selectedEmployeeLabel, setSelectedEmployeeLabel] = useState(localStorage.getItem("empName") || null);


  useEffect(() => {
    const handleClick = () => {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
        setFullScreen(true);
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          setFullScreen(false);
        }
      }
    };

    const cleanup = () => {
      if (isFullScreen && document.exitFullscreen) {
        document.exitFullscreen();
        setFullScreen(false);
      }
    };



    // Function to close the modal
    const closeModal = () => {
      setIsModalVisible(false);
      setModalContent(null);
    };


    const maximizeBtn = maximizeBtnRef.current;
    maximizeBtn.addEventListener('click', handleClick);

    return () => {
      maximizeBtn.removeEventListener('click', handleClick);
      cleanup();
    };
  }, [isFullScreen]);

  const fetchData = async (empId, startDate, endDate) => {
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}/attendance/list-weekly?empid=${empId}&start=${startDate.format('YYYY-MM-DD')}&end=${endDate.format('YYYY-MM-DD')}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setData(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching attendance data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {

    if (selectedEmployeeId) {
      const startOfWeek = selectedDate.clone().startOf('week');
      const endOfWeek = selectedDate.clone().endOf('week');
      fetchData(selectedEmployeeId, startOfWeek, endOfWeek);
    }
  }, [selectedEmployeeId, selectedDate]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(moment());
    }, 60000); // Update current time every minute

    return () => clearInterval(intervalId);
  }, []);

  const handleEmployeeChange = (selectedOption) => {
    if (selectedOption && selectedOption.value !== "all") {
      const { value, label } = selectedOption;
      setSelectedEmployee({ value, label });
      setSelectedEmployeeId(value);
      setSelectedEmployeeLabel(label);
      localStorage.setItem("defaultEmployeeId", value);
      localStorage.setItem("defaultEmployeeLabel", label);
  

    } else {
      // Show all employees if "Show All" is selected
      setSelectedEmployee(null);
      setSelectedEmployeeId(null);
      setSelectedEmployeeLabel("Show All");
      localStorage.removeItem("defaultEmployeeId");
      localStorage.removeItem("defaultEmployeeLabel");
     // setFilteredData(data); // Reset to the full data set
    }
  };

  const handlePrevWeek = () => setSelectedDate(selectedDate.clone().subtract(1, 'week'));
  const handleNextWeek = () => setSelectedDate(selectedDate.clone().add(1, 'week'));

  const calculateWidth = (hoursWorked) => {
    if (hoursWorked === null) return "100%"; // For weekends and holidays
    
    const calculatedWidth = (hoursWorked / maxHours) * 100;
    
    // Ensure a minimum width so the dot is visible, even for very short durations.
    return `${Math.max(calculatedWidth, 5)}%`; // Set 5% as the minimum width
  };
  

  const handleDotClick = (attendance) => {

    setModalContent(attendance);
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setModalData(null); // Optionally reset modal data
  };

  // Function to check if a given day is an additional off day
  const isAdditionalOffDay = (day) => {
    const dayOfWeek = day.format('dddd'); // Get full day name (e.g., "Saturday")
    const weekOfMonth = Math.ceil(day.date() / 7); // Calculate which week of the month (1st, 2nd, 3rd, etc.)
    
    return additionalOffDays[dayOfWeek]?.[`${weekOfMonth}st`] === "Full";
  };


  const calculatePresentLineWidth = (checkInTime) => {
    const start = moment(checkInTime, 'HH:mm:ss');
    const end = currentTime;
    const duration = moment.duration(end.diff(start));
    const hoursWorked = duration.asHours();
    return calculateWidth(hoursWorked);
  };

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
      <div className="page-header page-top-icons">
      <div className="row align-items-center">
            <div className="col-md-4">


                  <ReportingSelect
  value={selectedEmployeeId ? { value: selectedEmployeeId, label: selectedEmployeeLabel } : null}
  onChange={handleEmployeeChange}
/>
            </div>

            <div className="col-md-4 text-center week-switcher">
              <Button className="fa fa-chevron-circle-left" onClick={handlePrevWeek} />
              <Button style={{ margin: '0 1px' }}>
                <span style={{ margin: '0 1px', fontWeight: 'bold' }}>
                  {selectedDate.clone().startOf('week').format(dateFormat)} - {selectedDate.clone().endOf('week').format(dateFormat)}
                </span>
              </Button>
              <Button className="fa fa-chevron-circle-right" onClick={handleNextWeek} />
            </div>

            <div className="col-md-4 float-end ms-auto">
              <div className="d-flex title-head">
              <div className="view-icons">
                    <Link to="#" className="grid-view btn btn-link active mx-2">
                      <i className="fa fa-th" />
                    </Link>
                    <Link to="/attendance-employee" className="grid-view btn btn-link">
                     
                    <i class="fa fa-calendar-check"></i>      
                    </Link>

                    <Link to="/attendance-monthly" className="list-view btn btn-link">
                      <i className="fa fa-bars" />
                    </Link>

                    <Link to="#" className="grid-view btn btn-link">
                      <i className="las la-redo-alt" />
                    </Link>
                    <Link to="#" className="list-view btn btn-link" id="collapse-header" ref={maximizeBtnRef}>
                      <i className="las la-expand-arrows-alt" />
                    </Link>
                  </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            {loading ? (
              <div id="loader-wrapper_">
                <div className="loader">
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                </div>
              </div>
            ) : (
              <div className="weekly-timeline-container">
                <div className="weekly-timeline">
                  <div className="day-row header-row">
                    <div className="day-label">Date</div>
                    <div className="check-in-header">Check-in</div>
                    <div className="timeline-header"></div>
                    <div className="check-out-header">Check-out</div>
                    <div className="total-hours-header">Total Hours</div>
                  </div>
                  {data.length === 0 ? (
                    <div>No data available for this week</div>
                  ) : (
                    data.map((attendance) => {
                      const attendanceDate = moment(attendance.attendance_date);
                      const isHoliday = holidays.includes(attendanceDate.format('YYYY-MM-DD'));
                      const isWeekend = weekends.includes(attendanceDate.day());
                      const isAdditionalOff = isAdditionalOffDay(attendanceDate);

                      let lineClass = '';
                      let leftPosition = 0;
                      let rightPosition = 100;
                      //let checkInTime = attendance.check_in_time ? moment(attendance.check_in_time, 'HH:mm:ss').format('hh:mm A') : '--';
                      //let checkOutTime = attendance.check_out_time ? moment(attendance.check_out_time, 'HH:mm:ss').format('hh:mm A') : '--';
                      let checkInTime = attendance.check_in_time ? attendance.check_in_time : '--';
                      let checkOutTime = attendance.check_out_time ? attendance.check_out_time : '--';

                      let hoursWorked = parseFloat(attendance.total_hours);
                 
                      let width = "0%";

                      if (isHoliday || isWeekend || isAdditionalOff) {
                        lineClass = 'holiday';
                        width = "100%";
                      } else if (!attendance.check_in_time || attendance.attendance_status === "Not Checked In") {
                        lineClass = 'absent';
                        width = "100%";
                      } else {
                        lineClass = 'present';
                        width = attendance.check_out_time
                          ? calculateWidth(hoursWorked)
                          : calculatePresentLineWidth(attendance.check_in_time);
                      }

                      return (
                        <div className="day-row" key={attendanceDate}>
                          <div className="day-label">{attendanceDate.format('ddd, DD')}</div>
                          <div className="check-in-time">{checkInTime}</div>
                          <div className="timeline">
                            <div
                              className={`timeline-line ${lineClass}`}
                              style={{
                                height: '2%', /* Fixed height */
                                width: width, /* Dynamic width based on hours worked */
                                left: `${leftPosition}%`,
                                right: `${rightPosition}%`,
                              }}
                            >
                              {attendance.check_in_time && (
                                <div
                                  className="timeline-dot start-dot"
                                  onClick={() => handleDotClick(attendance)}
                                />
                              )}
                              {attendance.check_out_time && (
                                <div
                                  className="timeline-dot end-dot"
                                  onClick={() => handleDotClick(attendance)}
                                />
                              )}
                            </div>
                   
                            {(isHoliday || isWeekend || isAdditionalOff) && (
                              <div className="timeline-label">
                                {isHoliday ? 'Holiday' : isWeekend ? 'Weekend' : `${attendanceDate.format('dddd')} Off`}
                              </div>
                            )}

                          </div>
                          <div className="check-out-time">{checkOutTime}</div>
                          <div className="total-hours">{attendance.total_hours || '00:00'} </div>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="legend fixed-legend">
          <div className="legend-item">
            <span className="legend-color present-color"></span> Present
          </div>
          <div className="legend-item">
            <span className="legend-color holiday-color"></span> Holiday
          </div>
          <div className="legend-item">
            <span className="legend-color weekend-color"></span> Weekend
          </div>
          <div className="legend-item">
            <span className="legend-color absent-color"></span> Absent
          </div>
        </div>


>

    {/* Render the AttendanceInfoModal */}
    {modalContent && (
        <AttendanceInfoModal
          isVisible={isModalVisible}
          data={modalContent}
          onClose={handleCloseModal}
        />
      )}
  

      </div>
    </div>
  );
};

export default AttendanceEmployeeWeekly;
